import BaseComponent from 'foundation/base-component';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import EndeavorPlaylist from './endeavor-playlist';

class EndeavorPlaylistComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.render();
    }

    render() {
        ReactDOM.render(
            <Fragment>
                <EndeavorPlaylist content={this.options} />
            </Fragment>,
            this.element
        );
    }
}

export default EndeavorPlaylistComponent;
